import { render, staticRenderFns } from "./bQinZi.vue?vue&type=template&id=697bb984&scoped=true&"
import script from "./bQinZi.vue?vue&type=script&lang=js&"
export * from "./bQinZi.vue?vue&type=script&lang=js&"
import style0 from "./bQinZi.vue?vue&type=style&index=0&id=697bb984&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "697bb984",
  null
  
)

export default component.exports